import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";

import CommonRoutes from "@/routes/commonRoutes";
import ListRoutes from "@/routes/listRoutes";


Vue.use(VueRouter)

const index = [
    ...CommonRoutes,
    ...ListRoutes
]
const router = new VueRouter({
    mode: 'history',
    routes: index,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash
            };
        } else {
            return {x: 0, y: 0};
        }
    }
})

/***
 * Auth
 */


router.beforeEach((to, from, next) => {

    const publicPages = ["login"];
    const authRequired = publicPages.includes(to.name);
    const isLoggedIn = store.state.isLoggedIn;

    if (!authRequired && !isLoggedIn) {
        next("/login");
    } else if (authRequired && isLoggedIn) {
        let redirection = "/"
        next(redirection);
    } else {
        next();
    }
});

/***
 * Page title
 */
router.beforeEach((to, from, next) => {
    document.title = process.env.VUE_APP_NAME + '::' + to.meta.title
    next()
});

/**
 * roles**
 **/
router.beforeEach((to, from, next) => {
    if (to.meta.roles) {
        const roles = to.meta.roles
        const roleKey = store.state.user.role.key
        const state = !!roles.includes(roleKey)
        if (state) {
            next();
        } else {
            next('/401');
        }
    } else {
        next()
    }
})

export default router
